
import { dialogMessageService } from '../_services'
export const dialogMessage = {

  namespaced: true,

  state: {
    savedMessage: null,
    dialogMessages: [],
    hasUnreadMessage: false
  },

  mutations: {
    setSavedMessage(state, message) {
      state.savedMessage = message
    },

    setDialogMessages(state, messages) {
      state.dialogMessages = messages
    },

    setReadToMessage(state, msgId) {
      state.dialogMessages.find(el=> el.id == msgId).read = true
    },

    addMessage(state, message) {
      state.dialogMessages.push(message)
    },

    setHasUnreadMessage(state, flag) {
      state.hasUnreadMessage = flag
    }
  },

  actions: {
    saveMessage({ commit }, params) {
      return dialogMessageService.saveMessage(params).then(data => {
        commit('setSavedMessage', data)
      })
    },

    readMessage({ commit }, messageId){
      return dialogMessageService.readMessage(messageId).then(() => {
        commit
      })
    },

    checkUnreadMessage({ commit }){
      return dialogMessageService.checkUnreadMessage().then(data => {
        commit('setHasUnreadMessage', data)
      })
    }
  },

 
}